import * as React from 'react';
import {useState} from 'react';
import {TransactionForm} from "@/component/form/TransactionForm";
import {TransData} from "@/common/dto/TransData";
import {FtButton} from "@/common/FtButton";
import {useCreateTransaction} from "@/hook/useTransactions";
import {TransUtils} from "@/utils/TransUtils";
import {ErrorUtil} from "@/utils/ErrorUtil";
import styled from "styled-components";
import {FtDate} from "@/common/util/FtDate";

const Item = styled.div`
    border-right: 1px solid #aaa;
    padding: 8px;
`;

const ErrorMessage = styled.div`
    font-size: 14px;
    color: #ff0000;
    width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export function TransMultiAddView() {
    return <div style={{display: "flex", overflowX: "auto"}}>
        <Item><TransAddView /></Item>
        <Item><TransAddView /></Item>
        <Item><TransAddView /></Item>
        <Item><TransAddView /></Item>
        <Item><TransAddView /></Item>
    </div>;
}

function TransAddView() {
    const [data, setData] = useState<Partial<TransData>>({transactDate: new FtDate().ymd()});
    const [creating, setCreating] = useState(false);
    const [error, setError] = useState<string | undefined>();
    const createTransaction = useCreateTransaction();

    async function addAction() {
        setCreating(true);
        setError(undefined);

        try {
            await createTransaction.mutateAsync(TransUtils.validateTransData(data));
            setData({...data, amount: 0, detail: ""});
        } catch (e) {
            setError(ErrorUtil.getErrorMessage(e));
        }

        setCreating(false);
    }

    return <div style={{minWidth: 260, maxWidth: 260}}>
        <form onSubmit={(e) => {
            e.preventDefault();
            void addAction();
        }}>
            <TransactionForm data={data} setData={setData} hideLabel={true}/>
            <div style={{display: "flex", alignItems: "center", gap: 8}}>
                <FtButton type="submit" disabled={creating}>{creating ? "등록중..." : "등록"}</FtButton>
                {error && <ErrorMessage>{error}</ErrorMessage>}
            </div>
        </form>
    </div>;
}